/**
 * ENG-575 — a custom column has three states (mirroring container archiving):
 *   - active:   archived_at null
 *   - queued:   archived_at set AND archive_queued_at set — archived but an In
 *               Progress work order still holds a value, so the column stays
 *               visible + editable on the planners until that work order
 *               completes (the custom_columns_auto_hide_on_wo_complete trigger
 *               then clears archive_queued_at).
 *   - archived: archived_at set AND archive_queued_at null — faded read-only on
 *               the project planner, dropped from the production planner.
 *
 * These two predicates are exact complements; consumers replace bare
 * `!d.archived_at` checks with `isCustomColumnActive` so queued columns keep
 * showing, and use `isCustomColumnArchived` to drive the faded/locked rendering.
 */
export interface CustomColumnVisibilityFields {
  archived_at: string | null;
  archive_queued_at: string | null;
}

/** Still shown as a normal (editable) column — truly active OR archived-but-queued. */
export function isCustomColumnActive(def: CustomColumnVisibilityFields): boolean {
  return def.archived_at == null || def.archive_queued_at != null;
}

/** Fully archived: hidden from the production planner, faded read-only on the project planner. */
export function isCustomColumnArchived(def: CustomColumnVisibilityFields): boolean {
  return def.archived_at != null && def.archive_queued_at == null;
}
